import { useEffect, useState } from "react";
import UserProfile from "../../../Layouts/popovers/viewprofile/UserProfile";
import { getFlag } from "../../../utils/services";
import "./ParticipationPerson.css";

const ParticipantPerson = ({ person, audience }) => {
  const [flag, setFlag] = useState("");

  useEffect(() => {
    getUserFlag();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [person]);

  async function getUserFlag() {
    const userFlag = await getFlag(person?.country);
    if (userFlag) {
      setFlag(userFlag);
    }
  }

  const defaultAvatar =
    "https://res.cloudinary.com/onlinecoder/image/upload/v1690193097/fmjmbazdcvuftgdudpnx.jpg";

  return (
    <UserProfile userId={person?._id}>
      <div className="ParticipantsPersonWrapper">
        <img
          className="participation_person_img"
          referrerPolicy="no-referrer"
          src={person?.avatar !== "audience" ? person?.avatar : defaultAvatar}
          alt="userImg"
        />
        <div className="participation_person_box">
          <img
            style={{ display: `${!flag && "none"}` }}
            src={flag}
            width={"25px"}
            alt=""
          />
          <p>{audience ? person?.username : person?.firstName}</p>
        </div>
      </div>
    </UserProfile>
  );
};

export default ParticipantPerson;
